/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StatsOperationIncidentDto } from './StatsOperationIncidentDto';

export type StatsOperationImpactedDashboardDto = {
    datasourceName: string;
    datasourceType: StatsOperationImpactedDashboardDto.datasourceType;
    id: string;
    incidents: Array<StatsOperationIncidentDto>;
    name: string;
    recentOpenIncidentDate: number;
    urn: string;
};

export namespace StatsOperationImpactedDashboardDto {

    export enum datasourceType {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        POWER_BI = 'POWER_BI',
        QUICKSIGHT = 'QUICKSIGHT',
        TABLEAU = 'TABLEAU',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        COMPOSER = 'COMPOSER',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        ADF = 'ADF',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        ATLAN = 'ATLAN',
        DECLARATIVE = 'DECLARATIVE',
        _UNKNOWN_ = '_UNKNOWN_',
    }


}
